export const MODULE = {
  ID: "change-log",
  NAME: "Change Log"
};

/* -------------------------------------------- */

const TEMPLATE_DIR = `modules/${MODULE.ID}/templates`;

/* -------------------------------------------- */

export const TEMPLATE = {
  CHAT_CARD: `${TEMPLATE_DIR}/chat-card.hbs`,
  IMPORT_DIALOG: `${TEMPLATE_DIR}/import-dialog.hbs`,
  SETTINGS_EXPORT: `${TEMPLATE_DIR}/import-export-settings.hbs`,
  TAG_FORM: `${TEMPLATE_DIR}/tagify-app.hbs`
};

/* -------------------------------------------- */

export const BOOLEAN_ICON = {
  false: '<i class="fa-regular fa-xmark"></i>',
  true: '<i class="fa-regular fa-check"></i>'
};

/* -------------------------------------------- */

export const EMPTY_ICON = '<i class="fa-regular fa-empty-set"></i>';

/* -------------------------------------------- */

export const DELIMITER = ";";
